import { render, staticRenderFns } from "./CarrierInfo.vue?vue&type=template&id=5f367184&scoped=true&"
import script from "./CarrierInfo.vue?vue&type=script&lang=js&"
export * from "./CarrierInfo.vue?vue&type=script&lang=js&"
import style0 from "./CarrierInfo.vue?vue&type=style&index=0&id=5f367184&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f367184",
  null
  
)

export default component.exports